import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './User.module.scss';
import { showModal } from 'legacy/actions/modalActions';

const People = ({
  people = [],
  onClick,
  emptyString = 'No friends to display'
}) => {
  const { t } = useTranslation(['users']);
  const subset = people.slice(0, 6);
  return people.length > 0 ? (
    <div className={styles.friends} data-cy="user-friends">
      <div className={styles.friendList}>
        {subset.map((userObject) => {
          const person = userObject.user || userObject;
          return (
            <div
              key={person._id}
              className={styles.friend}
              title={person.name || `${person.firstName} ${person.lastName}`}
              {...(onClick && { onClick })}
            >
              {person.photo?.url || person.photoUrl ? (
                <img src={person.photo?.url || person.photoUrl} alt="" />
              ) : (
                <i className="fas fa-user-alt" />
              )}
            </div>
          );
        })}
        {subset.length < people.length && (
          <div className={styles.remainingFriends}>
            + {people.length - subset.length}
          </div>
        )}
      </div>
      {subset.length < people.length && (
        <div className={styles.viewMore} {...(onClick && { onClick })}>
          {t('users:profile.actions.viewAll')}
        </div>
      )}
    </div>
  ) : (
    <div className={styles.empty}>{emptyString}</div>
  );
};

export default connect(null, { showModal })(People);
